'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ngRedux = require('ng-redux');

var _ngRedux2 = _interopRequireDefault(_ngRedux);

var _events = require('ifeis-isomorphic/lib/redux/actions/events');

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _events2 = require('../events');

var _events3 = _interopRequireDefault(_events2);

var _ifeisIsomorphic = require('ifeis-isomorphic');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EventInfoDialogController = function () {
  function EventInfoDialogController($mdDialog, $ngRedux, fEventService, event, feis, hasManageGrants, registeredAndSaved, fAlert) {
    _classCallCheck(this, EventInfoDialogController);

    this._ = { $mdDialog: $mdDialog, $ngRedux: $ngRedux, fEventService: fEventService, fAlert: fAlert };
    this._events = fEventService.for(feis.id);
    this.event = event;
    this.feis = feis;
    this.statuses = fEventService.statuses;
    this.hasManageGrants = hasManageGrants;
    this.registeredAndSaved = registeredAndSaved || {};

    this.refresh();
    this.event.$name = (0, _ifeisIsomorphic.getDescription)(this.event);
  }

  _createClass(EventInfoDialogController, [{
    key: 'refresh',
    value: function refresh() {
      var _this = this;

      this.status = this.statuses.find(function (s) {
        return s.status === 'COMMENTS-UNRELEASED' && _this.event.status === 'RES' && (!_this.event.commentsReleased || _this.event.commentsReleased === 0) || s.status === _this.event.status;
      });

      // FIXME(joshdmiller): move to redux
      return this._events.participants(this.event.id).then(function (p) {
        if (_this.event.status === 'RES') {
          var unplacedParticipants = p.filter(function (p1) {
            return !p1.reg || p1.reg && !p1.reg.placement;
          });
          _this.participants = p.filter(function (p1) {
            return p1.reg && p1.reg.placement;
          }).sort(function (p1, p2) {
            return p1.reg.placement - p2.reg.placement;
          }).concat(unplacedParticipants);
        } else if (_this.event.status === 'RCL') {
          _this.participants = p.filter(function (p1) {
            return p1.reg && p1.reg.placement && p1.reg.placed;
          });
        } else {
          _this.participants = p;
        }
      });
    }
  }, {
    key: 'canReset',
    value: function canReset() {
      return this.hasManageGrants && ['RCL', 'RES', 'COMMENTS-UNRELEASED'].indexOf(this.status.status) !== -1;
    }
  }, {
    key: 'reset',
    value: function reset($event) {
      var _this2 = this;

      var prompt = this._.$mdDialog.confirm().title('Reset Event?').textContent('Would you like to reset ' + (0, _ifeisIsomorphic.getDescription)(this.event) + ' back to the stage? All existing data will be preserved.').ok('Return to Stage').cancel('Cancel');
      return this._.$mdDialog.show(prompt).then(function () {
        return _this2._.$ngRedux.dispatch((0, _events.resetEvent)(_this2.feis.id, _this2.event.id, _this2.event.version_id)).then(function (response) {
          if (response && response.errors && response.errors.status === 417) {
            var _ref = response.errors.data && response.errors.data.errors[0],
                title = _ref.title,
                detail = _ref.detail;

            _this2._.fAlert($event, title, detail);
          }
        });
      });
    }
  }, {
    key: 'qa',
    value: function qa($event) {
      var _this3 = this;

      var prompt = this._.$mdDialog.confirm().title('Return Event to QA?').textContent('Would you like to remove ' + (0, _ifeisIsomorphic.getDescription)(this.event) + ' from results and return it to QA? All existing data will be preserved.').ok('Return to QA').cancel('Cancel');
      return this._.$mdDialog.show(prompt).then(function () {
        return _this3._.$ngRedux.dispatch((0, _events.sendEventToQa)(_this3.feis.id, _this3.event.id, _this3.event.version_id));
      }).then(function (response) {
        if (response && response.errors && response.errors.status === 417) {
          var _ref2 = response.errors.data && response.errors.data.errors[0],
              title = _ref2.title,
              detail = _ref2.detail;

          _this3._.fAlert($event, title, detail);
        }
      });
    }
  }, {
    key: 'cancel',
    value: function cancel() {
      this._.$mdDialog.cancel();
    }
  }]);

  return EventInfoDialogController;
}();

exports.default = angular.module('ifeis.event-info', ['ngMaterial', 'ifeis.events', _ngRedux2.default]).factory('fEventInfoDialog', function ($mdDialog) {
  return function (feis, event, hasManageGrants, registeredAndSaved) {
    return $mdDialog.show({
      controller: EventInfoDialogController,
      controllerAs: 'info',
      template: require('./tpl.html'),
      locals: { event: event, feis: feis, hasManageGrants: hasManageGrants, registeredAndSaved: registeredAndSaved }
    });
  };
});


//////////////////
// WEBPACK FOOTER
// ./event-info/index.js
// module id = 479
// module chunks = 0